import { PosStatusPage } from './../pos-status/pos-status';
import { PosSalePage } from './../pos-sale/pos-sale';
import { PosCanceledPage } from './../pos-canceled/pos-canceled';
import { PosPaidPage } from './../pos-paid/pos-paid';
import { PosRunningPage } from './../pos-running/pos-running';
import { PosTablePage } from './../pos-table/pos-table';
import { PosDsPage } from '../pos-ds/pos-ds';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the PosDashboardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-pos-dashboard',
  templateUrl: 'pos-dashboard.html',
})
export class PosDashboardPage {
  tabTable = PosTablePage;
  tabRunning = PosRunningPage;
  tabPaid = PosPaidPage;
  tabCanceled = PosCanceledPage;
  tabSale = PosSalePage;
  tabStatus = PosStatusPage;
  tabDs = PosDsPage;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PosDashboardPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/pos-dashboard/pos-dashboard.ts